import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {useTranslation} from 'react-i18next';
import constants from "../../../utils/constants";
import './MarketTable.scss'

function MarketTable({ columns, keyInter, data, totalCount, page, rowsPerPage, handleClickTicker, handleChangePage}) {
    const { t } = useTranslation();

    function renderContent(column) {
        return column.label !== "logo" && t(`${keyInter}.${column.label}`);
    }

    return (
        <div className={"tableMarket"}>

            <Paper sx={{ width: '100%', overflow: 'visible', boxShadow: 0, background: 'transparent' }}>
                <TableContainer className={"tableContainer"} sx={{ overflow: 'visible' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead >
                            <TableRow>

                                {columns.map((column) => (
                                    <TableCell
                                        key={column.label}
                                        align={column.align || 'inherit'}
                                        style={{ minWidth: column.minWidth }}
                                        className={"tableHeader tableCell"}
                                        id={column.label}
                                    >
                                        {renderContent(column)}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody key={page} className={"tableRow tableBody-animate"}>
                            {data.map((row, rowIndex) => (
                                <TableRow onClick={() => handleClickTicker(row["ticker"])} hover role="checkbox" tabIndex={-1} key={row.id || rowIndex}>
                                    {columns.map((column) => {
                                        const value = row[column.label];
                                        let displayValue = value;
                                        
                                        if ((column.label === "category" || column.label === "exchange") && value) {
                                            displayValue = <span className="pill-badge">{value}</span>;
                                        }

                                        if (column.label === "changesPercentage" || column.label === "changePercentage" || column.label === "change") {
                                            const numValue = parseFloat(value);
                                            if (!isNaN(numValue)) {
                                                const isPositive = numValue >= 0;
                                                const colorPrice = isPositive ? constants.green : constants.red;
                                                const backgroundColor = colorPrice.includes('rgb') 
                                                    ? colorPrice.replace('rgb', 'rgba').replace(')', ', 0.1)') 
                                                    : colorPrice + "1A";
                                                
                                                displayValue = (
                                                    <span 
                                                        className="gain-loss-pill" 
                                                        style={{ color: colorPrice, backgroundColor }}
                                                    >
                                                        {isPositive ? '+' : ''}{value}
                                                    </span>
                                                );
                                            }
                                        }

                                        const isNumeric = ["price", "change", "changesPercentage", "changePercentage", "changeAmount", "volume"].includes(column.label);

                                        return (
                                                <TableCell
                                                    sx={{ padding: "10px" }}
                                                    className={`tableCell ${column.label === "ticker" ? "ticker" : ""} ${isNumeric ? "numeric-cell" : ""}`}
                                                    key={column.label} align={column.align || (isNumeric ? "right" : "inherit")}
                                                    id={column.label}
                                                    data-label={renderContent(column) || ""}>
                                                    {displayValue}
                                                </TableCell>
                                        );
                                    })}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                    />
            </Paper>
        </div>

    );
}

export default MarketTable;
